import Dropzone from 'react-dropzone';
import { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

type DropzoneWrapperProps = {
  children: React.ReactNode;
  disabled?: boolean;
  onDrop: (file: File) => void;
  ['data-testid']?: string;
};

const dropAreaStyle = {
  position: 'absolute',
  top: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
  fontSize: '2rem',
};

export const DropzoneWrapper = ({
  children,
  disabled = false,
  onDrop,
  ...props
}: DropzoneWrapperProps) => {
  const [dropAreaDisplayed, setDropAreaDisplayed] = useState(false);
  const { t } = useTranslation();

  return (
    <Dropzone
      noClick
      onDrop={(acceptedFiles) => {
        setDropAreaDisplayed(false);
        onDrop(acceptedFiles[0]);
      }}
      onDragEnter={() => setDropAreaDisplayed(true)}
      onDragLeave={() => setDropAreaDisplayed(false)}
      disabled={disabled}
    >
      {({ getRootProps, getInputProps }) => {
        return (
          <Box
            sx={{ position: 'relative', height: '100%', width: '100%' }}
            {...getRootProps()}
            data-testid={props['data-testid']}
          >
            <input {...getInputProps()} />
            {children}
            {dropAreaDisplayed && (
              <Box sx={dropAreaStyle}>
                <Typography variant="h1" color="text.secondary">
                  {t('common.dropFile')}
                </Typography>
              </Box>
            )}
          </Box>
        );
      }}
    </Dropzone>
  );
};
